import { runCordovaPluginCall } from '@helpers/cordovaBridge';

export interface IFirebaseAnalyticsContext {
  platform: 'ios' | 'android';
  appInstanceId: string;
  sessionId?: number;
}

// Read on demand: a session cached on the account can belong to another device
// or to an earlier visit. Analytics failure must not prevent the user action.
export function getFirebaseAnalyticsContext(): Promise<IFirebaseAnalyticsContext | undefined> {
  if (typeof window === 'undefined') { return Promise.resolve(undefined); }
  const cordova = (window as any).cordova;
  if (!cordova || !cordova.exec || !['ios', 'android'].includes(cordova.platformId)) {
    return Promise.resolve(undefined);
  }
  return new Promise(resolve => {
    let finished = false;
    const finish = (context?: IFirebaseAnalyticsContext) => {
      if (finished) { return; }
      finished = true;
      window.clearTimeout(timeout);
      resolve(context);
    };
    const timeout = window.setTimeout(() => finish(), 1000);
    try {
      const started = runCordovaPluginCall('VVFirebaseAnalytics.getSessionContext', () => {
        cordova.exec((value: any) => {
          if (!value || typeof value.appInstanceId !== 'string' || !/^[a-f0-9]{32}$/i.test(value.appInstanceId)) {
            finish();
            return;
          }
          finish({
            platform: cordova.platformId,
            appInstanceId: value.appInstanceId,
            sessionId: Number.isSafeInteger(value.sessionId) && value.sessionId > 0 ? value.sessionId : undefined,
          });
        }, () => finish(), 'VVFirebaseAnalytics', 'getSessionContext', []);
        return true;
      }, false);
      if (!started) { finish(); }
    } catch (_) {
      finish();
    }
  });
}



// WEBPACK FOOTER //
// ./src/services/firebase/firebaseAnalyticsContext.ts